import { StyledEngineProvider, ThemeProvider } from '@mui/material';
import { WebgateProvider as _WebgateProvider } from '@xvia/webgate-connect';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { env } from '@config/env';
import { QueryProvider } from '@providers/QueryProvider';
import { initOpenTelemetry } from '@utils/otel';
import { theme } from '@utils/theme';

import { App } from './App';

initOpenTelemetry();

const WebgateProvider = _WebgateProvider as any;

const baseName = (window as any).__APP_BASE__ || '/';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter basename={baseName}>
      <WebgateProvider portalUrl={env.portal.url}>
        <QueryProvider>
          <ThemeProvider theme={theme}>
            <StyledEngineProvider injectFirst>
              <App />
            </StyledEngineProvider>
          </ThemeProvider>
        </QueryProvider>
      </WebgateProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
